export default "__VITE_ASSET__DgyIB2r4__"